import { Fragment, useState } from "react";
import { toast } from "sonner";
import { Copy } from "@phosphor-icons/react";

const fmt$ = (n) => `$${Number(n || 0).toLocaleString("en-US", { maximumFractionDigits: 0 })}`;

const scoreColor = (s) => (s >= 80 ? "text-emerald-700" : s >= 60 ? "text-amber-700" : "text-[#D0021B]");

function copyShareLink(shareId) {
  const url = `${window.location.origin}/cash-health-check/r/${shareId}`;
  navigator.clipboard.writeText(url)
    .then(() => toast.success("Share link copied"))
    .catch((err) => {
      if (process.env.NODE_ENV !== "production") console.warn("Clipboard blocked", err);
      toast.error("Clipboard blocked");
    });
}

function LeadRow({ lead, open, onToggle }) {
  const runway = lead.computed?.runway_months || 0;
  return (
    <tr className="border-b border-zinc-100 hover:bg-zinc-50">
      <td className="px-4 py-2.5 tnum text-xs text-zinc-500 whitespace-nowrap">{new Date(lead.created_at).toLocaleString()}</td>
      <td className="px-4 py-2.5 font-mono text-xs">{lead.email}</td>
      <td className="px-4 py-2.5 font-medium">{lead.company || "—"}</td>
      <td className="px-4 py-2.5 font-mono text-[11px] text-zinc-600">
        {lead.ref ? (
          <span className="inline-block bg-amber-50 border border-amber-200 px-2 py-0.5" title={lead.referer || ""}>{lead.ref}</span>
        ) : (
          <span className="text-zinc-400">direct</span>
        )}
      </td>
      <td className="px-4 py-2.5 text-right tnum">{fmt$(lead.metrics?.monthly_revenue)}</td>
      <td className="px-4 py-2.5 text-right tnum">{runway >= 999 ? "∞" : `${runway}mo`}</td>
      <td className={`px-4 py-2.5 text-center font-display font-bold ${scoreColor(lead.computed?.health_score || 0)}`}>{lead.computed?.health_score}</td>
      <td className="px-4 py-2.5">
        <button onClick={onToggle} className="text-[10px] font-mono text-zinc-700 hover:text-[#FF3E00]" data-testid={`lead-toggle-${lead.id}`}>
          {open ? "HIDE" : "VIEW"}
        </button>
        <button
          data-testid={`copy-share-link-${lead.share_id}`}
          onClick={() => copyShareLink(lead.share_id)}
          className="ml-2 text-[10px] font-mono text-zinc-700 hover:text-[#FF3E00]"
        >
          <Copy size={10} className="inline" /> LINK
        </button>
      </td>
    </tr>
  );
}

function LeadDetailRow({ lead }) {
  return (
    <tr>
      <td colSpan={8} className="bg-zinc-50 p-4 border-b border-zinc-200">
        <div className="text-xs whitespace-pre-wrap text-zinc-700" data-testid={`lead-report-${lead.id}`}>
          {lead.report}
        </div>
      </td>
    </tr>
  );
}

export default function LeadsTablePanel({ leads }) {
  const [openId, setOpenId] = useState(null);
  return (
    <div className="border border-zinc-950">
      <table className="w-full text-sm">
        <thead className="bg-zinc-950 text-white">
          <tr className="text-xs tracking-wider uppercase">
            <th className="text-left px-4 py-2.5">Captured</th>
            <th className="text-left px-4 py-2.5">Email</th>
            <th className="text-left px-4 py-2.5">Company</th>
            <th className="text-left px-4 py-2.5">Source</th>
            <th className="text-right px-4 py-2.5">Revenue</th>
            <th className="text-right px-4 py-2.5">Runway</th>
            <th className="text-center px-4 py-2.5">Score</th>
            <th className="w-32" />
          </tr>
        </thead>
        <tbody data-testid="leads-tbody">
          {leads.length === 0 && (
            <tr><td colSpan={8} className="px-4 py-8 text-center font-mono text-xs text-zinc-400">NO LEADS YET — SHARE /cash-health-check ON LINKEDIN</td></tr>
          )}
          {leads.map((l) => (
            <Fragment key={l.id}>
              <LeadRow lead={l} open={openId === l.id} onToggle={() => setOpenId(openId === l.id ? null : l.id)} />
              {openId === l.id && <LeadDetailRow lead={l} />}
            </Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
}
